import {Autocomplete, Box, Button, CircularProgress, Container, FormControl, Grid, IconButton, Tab, Tabs, TextField, Typography} from '@mui/material';
import {Edit} from '@mui/icons-material';
import {GridColumns, GridRenderCellParams} from '@mui/x-data-grid';
import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {routeStateActions} from '@app/router/redux';
import {navbarComponentName} from '@app/router/redux/routeHandler';
import {useStyles} from '@app/screens/Styles/style';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import {fetchDivisionDataCreator} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/slice';
import {DataTableGrid} from '@app/components/widgets/DataGrid';
import { strings } from '@app/common/strings';
import AddNewPOBDialog from './AddNewPOBDialog';
import SetASPDialog from './SetASPDialog';
import {fetchPriorityProductsCreator} from './redux/slice';
import {fetchAverageSalePricesCreator} from './redux/slice';
import {pobReportActions} from './redux/slice';

import {pobReportStateSelector} from './redux/selectors';
const styles = {
  containerWidth:{
    width: '95%'
  }
}
export const POBManagement = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const divisionData = useSelector(
    approveExpenseStateSelector.getDivisionData(),
  );
  const [activeTab, setActiveTab] = useState(0);
  const [selectedDivision, setSelectedDivision] = useState<any>(null);
  const [pobSearchText, setPobSearchText] = useState('');
  const [addNewOpen, setAddNewOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const [setAspOpen, setSetAspOpen] = useState(false);
  const [aspDivision, setAspDivision] = useState<any>(null);
  const [aspSearchText, setAspSearchText] = useState('');
  const [aspEditData, setAspEditData] = useState<any>(null);
  const [pobFetched, setPobFetched] = useState(false);
  const [aspFetched, setAspFetched] = useState(false);
  const [pobPage, setPobPage] = useState(0);
  const [pobPageSize, setPobPageSize] = useState(10);
  const [aspPage, setAspPage] = useState(0);
  const [aspPageSize, setAspPageSize] = useState(10);

  const priorityProducts = useSelector(
    pobReportStateSelector.getPriorityProducts(),
  );
  const priorityProductsLoading = useSelector(
    pobReportStateSelector.getPriorityProductsLoading(),
  );

  const averageSalePrices = useSelector(
    pobReportStateSelector.getAverageSalePrices(),
  );
  const averageSalePricesLoading = useSelector(
    pobReportStateSelector.getAverageSalePricesLoading(),
  );

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const priorityProductColumns: GridColumns = useMemo(() => [
    {
      field: 'subBrandName',
      headerName: 'Sub Brand',
      headerClassName: 'boldHeader',
      flex: 1.2,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'skuName',
      headerName: 'SKU Name',
      headerClassName: 'boldHeader',
      flex: 1.8,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      headerClassName: 'boldHeader',
      flex: 1,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) =>
        params.row.startDate
          ? new Date(params.row.startDate).toLocaleDateString()
          : '',
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      headerClassName: 'boldHeader',
      flex: 1,
      sortable: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) =>
        params.row.endDate
          ? new Date(params.row.endDate).toLocaleDateString()
          : '',
    },
    {
      field: 'action',
      headerName: 'Action',
      headerClassName: 'boldHeader',
      flex: 0.5,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) => (
        <Box display="flex" justifyContent="center" width="100%">
          <IconButton
            size="small"
            color="primary"
            onClick={() => handleEdit(params.row)}
          >
            <Edit fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ], []);

  const aspColumns: GridColumns = useMemo(() => [
    {field: 'subBrandName', headerName: 'Sub Brand Name', headerClassName: 'boldHeader', flex: 1.2, sortable: true, align: 'center', headerAlign: 'center'},
    {field: 'skuName', headerName: 'SKU Name', headerClassName: 'boldHeader', flex: 1.8, sortable: true, align: 'center', headerAlign: 'center'},
    {field: 'averageSalePrice', headerName: 'ASP', headerClassName: 'boldHeader', flex: 0.8, sortable: true, align: 'center', headerAlign: 'center'},
    {
      field: 'startDate',
      headerName: 'Start Date',
      headerClassName: 'boldHeader',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      sortable: true,
      renderCell: (params: GridRenderCellParams) =>
        params.row.startDate ? new Date(params.row.startDate).toLocaleDateString() : '',
    },
    {
      field: 'endDate',
      headerName: 'End Date',
      headerClassName: 'boldHeader',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      sortable: true,
      renderCell: (params: GridRenderCellParams) =>
        params.row.endDate ? new Date(params.row.endDate).toLocaleDateString() : '',
    },
    {
      field: 'action',
      headerName: 'Action',
      headerClassName: 'boldHeader',
      flex: 0.5,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams) => (
        <IconButton size="small" color="primary" onClick={() => handleAspEdit(params.row)}>
          <Edit fontSize="small" />
        </IconButton>
      ),
    },
  ], []);

  const handleDivisionChange = (_event: any, value: any) => {
    setSelectedDivision(value);
    setPobSearchText('');
    setPobFetched(false);
    dispatch(pobReportActions.setPriorityProducts([]));
  };

  const handleGoClick = () => {
    if (selectedDivision?.value) {
      setPobFetched(true);
      dispatch(
        fetchPriorityProductsCreator({
          divisionId: selectedDivision.value,
          skuName: pobSearchText.trim() || undefined,
        }),
      );
    }
  };

  const handleAddNew = () => {
    setEditData(null);
    setAddNewOpen(true);
  };

  const handleAddNewClose = () => {
    setAddNewOpen(false);
    setEditData(null);
  };

  const handleEdit = (item: any) => {
    setEditData({
      id: item.id,
      divisionId: selectedDivision?.value ?? 0,
      skuId: item.skuId,
      skuName: item.skuName,
      subBrandId: item.subBrandId,
      subBrandName: item.subBrandName,
      motherBrandName: item.motherBrandName,
      averageSalePrice: item.averageSalePrice ?? 0,
      startDate: item.startDate,
      endDate: item.endDate,
    });
    setAddNewOpen(true);
  };

  const handleSetAsp = () => {
    setAspEditData(null);
    setSetAspOpen(true);
  };

  const handleSetAspClose = () => {
    setSetAspOpen(false);
    setAspEditData(null);
  };

  const handleAspEdit = (item: any) => {
    setAspEditData({
      id: item.id,
      divisionId: aspDivision?.value ?? 0,
      skuId: item.skuId,
      skuName: item.skuName,
      subBrandId: item.subBrandId,
      subBrandName: item.subBrandName,
      averageSalePrice: item.averageSalePrice ?? 0,
      startDate: item.startDate,
      endDate: item.endDate,
    });
    setSetAspOpen(true);
  };

  const handleAspDivisionChange = (_event: any, value: any) => {
    setAspDivision(value);
    setAspSearchText('');
    setAspFetched(false);
    dispatch(pobReportActions.setAverageSalePrices([]));
  };

  const handleAspGoClick = () => {
    if (aspDivision?.value) {
      setAspFetched(true);
      dispatch(
        fetchAverageSalePricesCreator({
          divisionId: aspDivision.value,
          skuName: aspSearchText.trim() || undefined,
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(
      routeStateActions.setNavbarComponentName(
        navbarComponentName.commonheader,
      ),
    );
    dispatch(
      routeStateActions.setNavbarComponentHeading(
        <div className={classes.navbarComponentHeadingEmpty}>
         {strings.ModuleSpecificUtilitie.pobManagementPage.pobManagement}
        </div>,
      ),
    );
    dispatch(fetchDivisionDataCreator());
    return () => {
      dispatch(routeStateActions.setNavbarComponentName(null));
      dispatch(pobReportActions.setPriorityProducts([]));
      dispatch(pobReportActions.setAverageSalePrices([]));
    };
  }, []);

  return (
    <Container maxWidth={false} style={styles.containerWidth}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label={strings.ModuleSpecificUtilitie.pobManagementPage.pobProduct} />
          <Tab label={strings.ModuleSpecificUtilitie.pobManagementPage.aspSet} />
        </Tabs>
      </Box>
      {activeTab === 0 && (
        <Box>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2 }}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="division-select-dropdown"
                  options={divisionData ?? []}
                  size="small"
                  value={selectedDivision}
                  getOptionLabel={(option: any) => option?.label ?? ''}
                  onChange={handleDivisionChange}
                  renderInput={(params) => (
                    <TextField {...params} size="small" placeholder="Search Division" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                fullWidth
                placeholder="Search by SKU Name"
                value={pobSearchText}
                onChange={(e) => setPobSearchText(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGoClick}
                disabled={!selectedDivision}
                sx={{ backgroundColor: '#322b7c', textTransform: 'none' }}
              >
                Go
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddNew}
              >
                {strings.AddNew}
              </Button>
            </Grid>
          </Grid>
          {priorityProductsLoading ? (
            <Box sx={{display: 'flex', justifyContent: 'center', mt: 3}}>
              <CircularProgress />
            </Box>
          ) : priorityProducts && priorityProducts.length > 0 ? (
            <Box sx={{mt: 2, height: 500, '& .MuiDataGrid-cell': {paddingLeft: '10px'}}}>
              <DataTableGrid
                columns={priorityProductColumns}
                data={priorityProducts}
                rowCount={priorityProducts.length}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={(page: number) => setPobPage(page)}
                onPageSizeChanged={(size: number) => setPobPageSize(size)}
                onSortingChange={() => {}}
                pgSize={pobPageSize}
                page={pobPage}
                paginationMode="client"
              />
            </Box>
          ) : selectedDivision && pobFetched ? (
            <Typography sx={{mt: 2, textAlign: 'center'}} color="textSecondary">
              No priority products found.
            </Typography>
          ) : null}
        </Box>
      )}
      {activeTab === 1 && (
        <Box>
          <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 2 }}>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <Autocomplete
                  id="asp-division-select-dropdown"
                  options={divisionData ?? []}
                  size="small"
                  value={aspDivision}
                  getOptionLabel={(option: any) => option?.label ?? ''}
                  onChange={handleAspDivisionChange}
                  renderInput={(params) => (
                    <TextField {...params} size="small" placeholder="Search Division" />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                fullWidth
                placeholder="Search by SKU Name"
                value={aspSearchText}
                onChange={(e) => setAspSearchText(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAspGoClick}
                disabled={!aspDivision}
                sx={{ backgroundColor: '#322b7c', textTransform: 'none' }}
              >
                Go
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSetAsp}
              >
                Add ASP
              </Button>
            </Grid>
          </Grid>
          {averageSalePricesLoading ? (
            <Box sx={{display: 'flex', justifyContent: 'center', mt: 3}}>
              <CircularProgress />
            </Box>
          ) : averageSalePrices && averageSalePrices.length > 0 ? (
            <Box sx={{mt: 2, height: 500, '& .MuiDataGrid-cell': {paddingLeft: '10px'}}}>
              <DataTableGrid
                columns={aspColumns}
                data={averageSalePrices}
                rowCount={averageSalePrices.length}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={(page: number) => setAspPage(page)}
                onPageSizeChanged={(size: number) => setAspPageSize(size)}
                onSortingChange={() => {}}
                pgSize={aspPageSize}
                page={aspPage}
                paginationMode="client"
              />
            </Box>
          ) : aspDivision && aspFetched ? (
            <Typography sx={{mt: 2, textAlign: 'center'}} color="textSecondary">
              No average sale prices found.
            </Typography>
          ) : null}
        </Box>
      )}
      <AddNewPOBDialog
        open={addNewOpen}
        onClose={handleAddNewClose}
        divisionData={divisionData}
        editData={editData}
        selectedDivision={selectedDivision}
        onSaveSuccess={() => {
          if (selectedDivision?.value) {
            dispatch(
              fetchPriorityProductsCreator({
                divisionId: selectedDivision.value,
                skuName: pobSearchText.trim() || undefined,
              }),
            );
          }
        }}
      />
      <SetASPDialog
        open={setAspOpen}
        onClose={handleSetAspClose}
        divisionData={divisionData}
        editData={aspEditData}
        selectedDivision={aspDivision}
        onSaveSuccess={() => {
          if (aspDivision?.value) {
            dispatch(
              fetchAverageSalePricesCreator({
                divisionId: aspDivision.value,
                skuName: aspSearchText.trim() || undefined,
              }),
            );
          }
        }}
      />
    </Container>
  );
};
